import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { useTranslation, Trans } from 'react-i18next';

import {
    makeStyles,
    Tab,
    Tabs,
  } from "@material-ui/core";

const useStylesAll = makeStyles(theme => ({
  tab: {
    textTransform: "none",
    width: "fit-content",
    marginRight: "25px",
    "&.MuiTab-root": {
      minWidth: "auto",
      minHeight: "unset",
      padding: "0px",
    },
    '&.Mui-selected': {
      color: "#962013",
    },
  },
}));

function RegisterProgressBar(props) {
    const { active } = props;
    const classes = useStylesAll();
    const { t, i18n } = useTranslation('register');
    const history = useHistory();

    // const changeTab = (event, newValue) => {
    //   setTab(newValue);
    // };

    function toLogin() {
      history.push("/"+i18n.language+"/login");
    }

    function toRegister() {
      history.push("/"+i18n.language+"/register");
    }

    return (
        <Tabs
            value={active}
            // onChange={changeTab}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
            TabIndicatorProps={{ style: { background: '#962013', bottom: "22px" } }}
        >
            <Tab value="login" label={t('login_tab')} disableRipple="true" className={classes.tab} onClick={toLogin} />
            {/* <Tab value="register" label={t('register_tab')} disableRipple="true" className={classes.tab} onClick={toRegister} /> */}
        </Tabs>
    );
}

export default RegisterProgressBar;
